export const enum Actions {
  InviteUsers = 'InviteUsers',
  AssignRoles = 'AssignRoles',
  AssignManager = 'AssignManager',
  AssignDepartment = 'AssignDepartment',
  AssignLocation = 'AssignLocation',
  SetTimeOffLimit = 'SetTimeOffLimit',
}
